import { Link } from 'react-router-dom';
import LegalLayout from '@/components/LegalLayout';
import { Button } from '@/components/ui/button';
import { BUSINESS } from '@/lib/legal';

export default function DeleteAccount() {
  return (
    <LegalLayout
      title="Delete My Account"
      updated={false}
      intro={`You can permanently delete your ${BUSINESS.brand} account and personal data at any time. Here's what happens and how to do it.`}
    >
      <h2>What deleting your account does</h2>
      <p>When you delete your account, we:</p>
      <ul>
        <li>Permanently remove your personal identifiers — your name, email, and phone number.</li>
        <li>Delete your password and any push-notification device tokens (so you stop receiving notifications).</li>
        <li>Deactivate the account so it can no longer be used to log in.</li>
      </ul>
      <p>
        For accounting, tax, and payment-dispute reasons we retain your past payment/transaction records in{' '}
        <strong>anonymized</strong> form (no longer linked to your personal details).
      </p>

      <p>
        <strong>This is permanent and cannot be undone.</strong> Any remaining, unused tiffin credits are forfeited
        on deletion. If you would like a refund on unused credits, please review our{' '}
        <Link to="/refunds">Refund &amp; Cancellation Policy</Link> and contact us <em>before</em> deleting.
      </p>

      <h2>How to delete your account</h2>
      <p><strong>In the mobile app or on the website:</strong></p>
      <ul>
        <li>Log in to your account.</li>
        <li>Go to <strong>Profile</strong>.</li>
        <li>Tap <strong>Delete My Account</strong> and confirm with your password.</li>
      </ul>

      <p><strong>Prefer we handle it?</strong> Email <a href={`mailto:${BUSINESS.supportEmail}`}>{BUSINESS.supportEmail}</a> from the address on your account and we will process the deletion for you.</p>

      <div className="mt-6 flex flex-wrap gap-3">
        <Link to="/cxlogin">
          <Button
            data-testid="delete-account-login-btn"
            className="h-11 rounded-full px-6 bg-saffron hover:bg-saffron-hover text-white font-semibold"
          >
            Log in to delete my account
          </Button>
        </Link>
        <a href={`mailto:${BUSINESS.supportEmail}?subject=Account%20deletion%20request`}>
          <Button
            data-testid="delete-account-email-btn"
            variant="outline"
            className="h-11 rounded-full px-6 border-charcoal/20 font-semibold"
          >
            Email us to delete
          </Button>
        </a>
      </div>
    </LegalLayout>
  );
}
